import {Injectable} from '@angular/core';
import {webapi} from '../../shared/my-constants';
import 'rxjs/add/operator/toPromise';
import {Headers, Http, Response} from '@angular/http';

@Injectable()
export class TinvPharmacySaleListService {
  private AddRecord = webapi + 'tinv_pharmacy_bill_recept/create';
  private GetList = webapi + 'tinv_pharmacy_bill_recept/recepitlist/';
  private headers = new Headers({'Content-Type': 'application/json'});
  private AddReturnReceptRecord = webapi + 'tinv_pharmacy_bill_return_receipt/create';
  private getKitList = webapi + 'inv_item_kit_package/getKitList/';
  private getKitItemsUrl = webapi + 'inv_item_kit_package_items/getItemKitPackage/';
  constructor(private http: Http) {
  }

  onAddAllrecept(model) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers}).toPromise().then(response => response.json()).catch(this.handleError);
  }

  getListOfRecepts(id) {
    return this.http.get(this.GetList + id).toPromise().then(response => response.json()).catch(this.handleError);
  }

  onAddAllReturnRecept(model) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddReturnReceptRecord, JSON.stringify(model), {headers: this.headers}).toPromise().then(response => response.json()).catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

  getKitListService(currentPage: number, size: number, qString: string, sort: string, col: string): Promise<any> {
    return this.http.get(`${this.getKitList}?page=${currentPage}&size=${size}&qString=${qString}&sort=${sort}&col=${col}`)
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }

  getKitItems(kitId: number): Promise<any> {
    return this.http.get(`${this.getKitItemsUrl}${kitId}`)
      .toPromise()
      .then((response) => response.json())
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/inventory/tinv-pharmacy-sale-list/tinv-pharmacy-sale-list.service.ts